/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

export default function Widget() {
    return (
        <div className="content-wrapper">
            Hi Widget
        </div>
    )
}